import { Box, Grid, Stack, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { StaticPagesFeatureCardComponent, StaticPagesFeatureListComponent } from "../../../api/content-client/service";
import { Image } from "../../../fe-ui/atoms/Image";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererBody } from "./ContentRendererBody";

const gridItemWidthBy: Record<'one' | 'two' | 'three' | 'four', number> = {
  one: 12,
  two: 6,
  three: 4,
  four: 3,
};

const FeatureCard = (props: StaticPagesFeatureCardComponent) => {
  const {
    align,
    backgroundColor,
    body,
    dimming,
    media,
    title,
    variant,
  } = props || {};

  return (
    <Stack
      direction="column"
      alignItems="stretch"
      pt={variant === "bottom" ? "60%" : undefined}
      pb={variant === "top" ? "60%" : undefined}
      sx={[
        {
          backgroundColor,
          borderRadius: 3,
          height: '100%',
          position: 'relative',
          overflow: "hidden",
        },
      ]}
    >
      {media?.data?.attributes?.url ? (
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
          }}
        >
          <Image
            alt={media?.data?.attributes?.alternativeText}
            draggable={false}
            src={media?.data?.attributes?.url}
          />
        </Box>
      ) : null}
      {dimming === true ? (
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background: `linear-gradient(${variant === "bottom" ? '180deg' : '0deg'}, rgba(0, 0, 0, 0.00) 37.91%, #000 99.99%, #737373 100%)`,
          }}
        />
      ) : null}
      <Box
        p={3}
        mt={variant === "bottom" ? "auto" : undefined}
        sx={{ position: "relative", textAlign: align === "center" ? "center" : "left" }}
      >
        {title ? <Typography color="common.white" variant="h5" mb={1}>{title}</Typography> : null}
        {body ? <ContentRendererBody
          body={body}
          paragraphSx={{ color: "common.white" }}
        /> : null}
      </Box>
    </Stack>
  )
}

export function ContentRendererFeatureList(block: StaticPagesFeatureListComponent) {
  const {
    containerProps,
    items,
    maxItemsPerRow,
    scroll,
  } = block || {};

  return (
    <ContentRendererContainer containerProps={containerProps}>
      {scroll === true ? (
        <Swiper
          spaceBetween={24}
          breakpoints={{
            0: {
              slidesPerView: 1.5
            },
            600: {
              slidesPerView: 2.5,
            },
            900: {
              slidesPerView: 3.5,
            },
          }}
        >
          {items?.map((card) => (
            <SwiperSlide key={card.id} style={{ height: "auto" }}>
              <FeatureCard {...card} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Grid container spacing={3}>
          {items?.map((card) => (
            <Grid
              key={card.id}
              item
              xs={12}
              md={gridItemWidthBy[maxItemsPerRow || 'four']}
            >
              <FeatureCard {...card} />
            </Grid>
          ))}
        </Grid>
      )}
    </ContentRendererContainer>
  );
}
